<div class="mainbox {{userClass}}">
  <div class="inputbox">
    <dp-date-picker
      id="{{name}}"
      name="{{name}}"
      [label]="label"
      [(ngModel)]="selectedDate"
      (onChange)="change($event)"
      [mode]="'day'"
      tabindex="{{tabOrder}}"
      [displayDate]="displayDate"
      [minDate]="validationMinDate"
      [maxDate]="validationMaxDate"
      [disabled]="disabled"
      [required]="required"
      #txt="ngModel"
      placeholder="{{label}} {{'ClientApp.Projects.FrameWorkShell.Shared.Controls.Date.Enter' | translate}}"
      [config]="config"
      [theme]="'dp-material dp-main'">
    </dp-date-picker>
  </div>
  <div *ngIf="group?.controls[name].touched && group?.controls[name]?.invalid" class="error errorsize">
    <span [hidden]="!group?.controls[name].errors?.required">
      {{'ClientApp.Projects.FrameWorkShell.Shared.Controls.Date.DateNotSelected' | translate}}
    </span>
    <span [hidden]="!group?.controls[name].errors?.dateRange"> {{group?.controls[name].errors?.dateRange}} </span>
  </div>
</div>
